import React from 'react';
import { Chip } from '@mui/material';

const ScoreChip = ({ score, maxScore = 10, size = 'small' }) => {
  const percentage = maxScore > 0 ? (score / maxScore) * 100 : 0;

  let color = 'error';
  let label = score?.toFixed(1) || '0.0';

  if (percentage >= 85) {
    color = 'success';
  } else if (percentage >= 60) {
    color = 'warning';
  }

  return (
    <Chip
      label={label}
      color={color}
      size={size}
      sx={{ fontWeight: 700, minWidth: 50 }}
    />
  );
};

export default ScoreChip;
